<template>
  <span> {{ $setInfoDecimal(Surplus) }}</span>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState('user',['userSurplus']),
    Surplus () {
      return this.userSurplus
    }
  },
  methods: {
  ...mapActions('user',['getSurplus']),
  },
  created() {
    this.getSurplus()
  },
}
</script>
